import * as React from 'react';

interface Props {
  label: string;
  id: string;
  onInput?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: boolean;
  disabled?: boolean;
  name?: string;
}

export const SwitchButton = ({
  label,
  id,
  onInput,
  onChange,
  disabled,
  name,
  value,
}: Props) => {
  return (
    <div className=" mb-4 flex flex-row min-h-[1.5rem]  ">
      <p className=" w-full inline-block pt-2 pl-1 ">{label}</p>
      <label className="flex items-end cursor-pointer">
        <input
          type="checkbox"
          checked={value}
          id={id}
          name={name}
          onInput={onInput}
          onChange={onChange}
          disabled={disabled || !navigator.onLine}
          className="sr-only peer"
        />
        <div
          className={` block relative ${
            value ? 'bg-pyrllSucess' : 'bg-inputBackground'
          }  h-8 w-14 rounded-full before:absolute mt-1
          before:bg-[#FFF] before:w-6 before:h-6 before:p-1 before:rounded-full before:transition-all before:duration-500
          before:top-1 before:shadow-xs before:md:shadow before:border before:border-gray-100
          before:left-1 peer-checked:before:left-7 peer-checked:before:bg-white peer-checked:bg-pyrllSucess`}
        ></div>
      </label>
    </div>
  );
};
